import type { User } from "../types";

/**
 * The assignee of a ticket, in the shape Avatar wants.
 *
 * A ticket carries its assignee's id and name but not their chosen tint, and
 * widening every ticket payload to repeat a colour that is the same on all of
 * an agent's rows would be a lot of duplication for one circle. The agent list
 * is already fetched for the assignee dropdowns, so the colour is looked up
 * from there and the ticket queries stay as they are.
 *
 * Falls back to a null colour -- not to a guessed one -- when the agent is not
 * in the list, which is what a deactivated assignee looks like. Avatar then
 * derives its usual tint from the id, exactly as before.
 */
export function assigneeOf(
  users: User[],
  id: number | null,
  name: string | null,
): { id: number; name: string | null; color: string | null } | null {
  if (id === null) return null;

  return {
    id,
    name,
    color: users.find((user) => user.id === id)?.avatarColor ?? null,
  };
}
